import React from 'react';
import styled from 'styled-components/macro';
import { hexToRgb } from 'helpers/hexToRgb';
import { StyledButton } from 'components/Button/Button';

interface IProps {
  title: string;
  icon: React.ReactElement;
  onClick: (e: React.MouseEvent) => void;
  invert?: boolean;
}

const StyledToolItem = styled(StyledButton)<Pick<IProps, 'invert'>>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.spacing[6]};
  height: ${({ theme }) => theme.spacing[6]};
  ${({ theme, invert }) => invert && `
    background: ${theme.colors.white};
    color: ${theme.colors.black};
  `}

  @media (min-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    &[data-tooltip]:hover {
      position: relative;

      &:before {
        content: attr(data-tooltip);
        padding: ${({ theme }) => `${theme.spacing[.5]} ${theme.spacing[1]}`};
        position: absolute;
        background: ${({ theme }) => `rgba(${hexToRgb(theme.colors.black, 'string')}, .8)`};
        color: white;
        white-space: nowrap;
        z-index: 1;
        border-radius: ${({ theme }) => theme.radius.sm};
        font-size: ${({ theme }) => theme.typography['-2']};
        font-weight: 400;
        top: ${({ theme }) => `calc(100% +  ${theme.spacing[1]})`};
        left: 50%;
        transform: translateX(-50%);
      }
    } 
  }
`;

const ToolsItem: React.FC<IProps> = ({ icon, onClick, title, invert }) => {
  return (
    <StyledToolItem onClick={onClick} data-tooltip={title} invert={invert}>
      {icon}
    </StyledToolItem>
  );
};

export { ToolsItem };
